import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, MyJwtPayload } from '../../auth/services/auth.service';
import { SessionTimeoutService } from '../../auth/services/session-timeout.service';
import { LogoutService } from '../../auth/services/logout.service';
import { ROUTE_META, RouteMeta } from '../route-meta';

@Component({
  selector: 'app-navigation-layout',
  templateUrl: './navigation-layout.component.html',
  styleUrl: './navigation-layout.component.scss'
})
export class NavigationLayoutComponent implements OnInit {
  isSidebarCollapsed = false;
  isLayoutHidden = false;
  userEmail?: string;
  displayName?: string;
  userRoles: string[] = [];

  navLinks: RouteMeta[] = [];
  adminNavLinks: RouteMeta[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private sessionTimeout: SessionTimeoutService,
    private logoutService: LogoutService
  ) { }

  async ngOnInit() {
    await this.authService.getCurrentUser();
    this.displayName = this.authService.getDisplayName();
    this.userRoles = this.authService.getUserRoles();

    console.log('[Navigation Layout] - User Roles', this.userRoles);

    this.setNavLinks();
  }

  setNavLinks(): void {
    const canAccess = (meta: RouteMeta) =>
      meta.roles.includes('*') ||
      this.userRoles.some(role => meta.roles.includes(role));

    this.navLinks = ROUTE_META.filter(m => m.category === 'main' && canAccess(m));
    this.adminNavLinks = ROUTE_META.filter(m => m.category === 'admin' && canAccess(m));
  }

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  toggleLayout() {
    this.isLayoutHidden = !this.isLayoutHidden;
  }

  logout(): void {
    this.logoutService.confirmAndLogout();
  }

}
